<template>
  <div class="apiTest_doc">
    <div class="apiTest_doc_item">
      <p class="apiTest_doc_item_top">
        <i class="iconfont iconapiwendang_jiekoushuoming"></i>
        <span>{{$t('apiTestDoc.接口说明')}}</span>
      </p>
      <div class="apiTest_doc_url">
        <span>URL</span>
        <el-input
          class="apiTest_api_url"
          disabled
          v-model="apiTestData.apiBaseUrl"
          :placeholder="$lang('请输入内容')"
        ></el-input>
        <button class="apiTest_send" @click.stop="sendClick">{{$lang('发送')}}</button>
      </div>
    </div>
    <template v-if="apiTestData._headerData">
      <h3 class="apiTest_doc_h3">Headers</h3>
      <table border cellspacing="0" cellpadding="0">
        <tr>
          <td class="first">apiAccount</td>
          <td class="second">
            <input
              type="text"
              v-model.trim="headersSignForm._headerData.apiAccount"
              :placeholder="$lang('请输入')"
            />
          </td>
        </tr>
        <tr>
          <td class="first">digest</td>
          <td class="second">
            <input v-model.trim="headersSignForm._headerData.digest" :placeholder="$lang('请输入')" />
          </td>
        </tr>
        <tr>
          <td class="first">timestamp</td>
          <td class="second">
            <input v-model.trim="headersSignForm._headerData.timestamp" :placeholder="$lang('请输入')" />
          </td>
        </tr>
      </table>
    </template>
    <template v-if="apiTestData.data">
      <div class="apiTest_doc_item">
        <p class="apiTest_doc_item_top">
            <i class="iconfont iconapiwendang_body"></i>
          <span>Body</span>
        </p>
        <table border cellspacing="0" cellpadding="0">
          <tr v-for="(vulue, key,index) in apiTestData.data" :key="index + key">
            <td class="first">{{key}}</td>
            <td class="second">
              <el-input
                v-if="apiTestData.textareaData[key]"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 8}"
                :placeholder="$lang('请输入内容')"
                v-model.trim="headersSignForm[key]"
              ></el-input>
            <input v-else v-model.trim="headersSignForm[key]" :placeholder="$lang('请输入')"/>
            </td>
          </tr>
        </table>
      </div>
    </template>
    <div class="apiTest_doc_item">
      <p class="apiTest_doc_item_top">
            <i class="iconfont iconapiwendang_Response"></i>
        <span>Response</span>
      </p>
      <!-- <api-errcode-table></api-errcode-table> -->
      <json-viewer class="pre_api" :expand-depth="5" :value="ResponseJson"></json-viewer>
    </div>
      <div class="apiTest_doc_item">
          <p class="apiTest_doc_item_top">
            <i class="iconfont iconapiwendang_cuowudaima"></i>
            <span>{{$t('apiTestDoc.错误代码')}}</span>
          </p>

      <!-- 错误代码 -->
      <api-errcode-table :dataList="apiTestData.errcodeJson"></api-errcode-table>
        </div>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from "@/constants";
import apiErrcodeTable from './apiErrcodeTable'
export default {
  props: ["apiTestData"],
  components:{apiErrcodeTable},
  data() {
    return {
      headersSignForm: {
        _headerData: this.apiTestData._headerData || {},
        ...(this.apiTestData.data || {}),
      },
      ResponseJson: this.apiTestData.ResponseJson,
    };
  },
  methods: {
     deepCopy (obj) {
        // 创建一个新对象
        let result = {}
        let temp = null
        let key = null
        let keys = Object.keys(obj)
        keys.map((item) => {
            key = item
            temp = obj[key]
            // 如果字段的值也是一个对象则递归操作
            if (temp && typeof temp === 'object') {
                result[key] = this.deepCopy(temp)
            } else {
                result[key] = temp
            }

        })
        return result
    },
    sendClick() {
      const headersSignForm = this.deepCopy(this.headersSignForm);
      if (
        this.apiTestData &&
        this.apiTestData.requestData &&
        this.apiTestData.requestData.length
      ) {
        const dataKeys = Object.keys(headersSignForm);
        for (const i of dataKeys) {
          if (i == "_headerData") {
            //验证请求头
            const keys = Object.keys(headersSignForm._headerData);
            for (const v of keys) {
              if (
                this.apiTestData.requestData.includes(v) &&
                !headersSignForm._headerData[v]
              ) {
                return this.$message.warning(`${this.$t('apiTestDoc.请求头Headers参数')} ${v} ${this.$t('apiTestDoc.不能为空')}`);
              }
            }
          } else if (
            this.apiTestData.requestData.includes(i) &&
            !headersSignForm[i]
          ) {
            //验证请求体
            return this.$message.warning(`${this.$t('apiTestDoc.参数')} ${i} ${this.$t('apiTestDoc.不能为空')}`);
          }
        }
      }

      this.$API['apiTestApiMock'](headersSignForm,this.apiTestData.apiUrl).then(
        (res) => {
          if (res.code == RESPONSE_SUCCESS) {
            this.$message.success(this.$lang("获取成功"));
          } else {
            this.$message.error(res.msg);
          }
            this.ResponseJson = res;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>